import lighthouse from "@lighthouse-web3/sdk";
import axios from "axios";
import { notify } from "./notification";
import { baseUrl } from "../config/urls";
import store from "../../store/store";
import { providerAC } from "../../store/action-creators";
import Web3 from "web3";
import { availableNetworks } from "../config/availableNetworks";
import { useSyncExternalStore } from "react";

declare global {
  interface WindowEventMap {
    "eip6963:announceProvider": CustomEvent;
  }
}
let providers: EIP6963ProviderDetail[] = [];
export const evmStore: any = {
  value: () => providers,
  subscribe: (callback: () => void) => {
    function onAnnouncement(event: EIP6963AnnounceProviderEvent) {
      if (providers.map((p) => p.info.uuid).includes(event.detail.info.uuid))
        return;
      providers = [...providers, event.detail];
      callback();
    }
    window.addEventListener("eip6963:announceProvider", onAnnouncement);
    window.dispatchEvent(new Event("eip6963:requestProvider"));
    return () =>
      window.removeEventListener("eip6963:announceProvider", onAnnouncement);
  },
};

export const useSyncProviders = () =>
  useSyncExternalStore(evmStore.subscribe, evmStore.value, evmStore.value);

const getProvider = async (): Promise<any | undefined> => {
  const providers = evmStore.value();
  if (providers.length > 0) {
    const metamaskProvider = providers.find(
      (provider: EIP6963ProviderDetail) => provider.info.name === "MetaMask"
    );
    if (metamaskProvider) {
      store.dispatch(providerAC.setProvider({ metamaskProvider: metamaskProvider?.provider }));
      return metamaskProvider;
    } else {
      notify("MetaMask provider not found", "error");
      return undefined;
    }

  }
};

export const get_metamask_account = async (): Promise<string | undefined> => {
  try {
    const ethereumProviderDetails = await getProvider();
    let account: string | undefined = undefined;
    if (ethereumProviderDetails) {
      const accounts = await ethereumProviderDetails.provider.request({
        method: "eth_requestAccounts"
      })
      account = accounts[0];
    }
    return account;
  } catch (error) {
    notify(`Error:${error}`, "error");
    return undefined;
  }
};

export const sign_message_metamask = async (): Promise<
  | {
      message: string;
      signed_message: string;
      address: string;
      alternativeAddress: string;
    }
  | undefined
> => {
  try {
    const ethereumProviderDetails = await getProvider();

    const address = await get_metamask_account();
    if (address) {
      const res = await axios.get(
        `${baseUrl}/api/auth/get_message?publicKey=${address}&encryption=true`
      );
      const message = res.data;

      const msg = `0x${Buffer.from(message, "utf8").toString("hex")}`;
      const signed_message = await ethereumProviderDetails.provider.request({
        method: "personal_sign",
        params: [msg, address],
      });

      return {
        message,
        signed_message,
        address,
        alternativeAddress: address,
      };
    } else {
      throw new Error("Address is not available");
    }
  } catch (error) {
    notify(`Something went wrong`, "error");
    console.error(error);
    return undefined;
  }
};

export const sign_auth_message_metamask = async (): Promise<
  string | undefined
> => {
  try {
    const ethereumProviderDetails = await getProvider();
    const address = await get_metamask_account();
    if (address) {
      const messageRequested = await lighthouse.getAuthMessage(address);
      const signed_message = await ethereumProviderDetails.provider.request({
        method: "personal_sign",
        params: [messageRequested?.data?.message, address],
      });

      return signed_message;
    } else {
      throw new Error("Address is not available");
    }
  } catch (error) {
    notify(`Something went wrong`, "error");
    console.error(error);
    return undefined;
  }
};

export const checkMetamaskCurrentChain = async (): Promise<string | null> => {
  const ethereumProviderDetails = await getProvider();
  if (ethereumProviderDetails) {
    const chainID = await ethereumProviderDetails.provider 
  .request({ method: "eth_chainId" })
  
    const currentChainID = Web3.utils.toHex(chainID + "");
    const keys = Object.keys(availableNetworks);
    const ifAvailableNetworkExist = keys.filter((item) => {
      return availableNetworks[item]["chainId"] === currentChainID;
    });
    return ifAvailableNetworkExist.length > 0
      ? ifAvailableNetworkExist[0]
      : null;

  }
  return null;
};


export const changeAddNetworkMetamask = async (chainName: string) => {
  let chainConfig = availableNetworks[chainName];
  const ethereumProviderDetails = await getProvider();
 if ((window as any).ethereum?.net_version !== chainConfig["chainId"]) {
   try {
     await ethereumProviderDetails.provider.request({
       method: "wallet_switchEthereumChain",
       params: [{ chainId: chainConfig["chainId"] }],
     });
   } catch (err:any) {
     if (err.code === 4902) {
       await ethereumProviderDetails.provider.request({
         method: "wallet_addEthereumChain",
         params: [
           {
             chainName: chainConfig["chainName"],
             chainId: chainConfig["chainId"],
             nativeCurrency: {
               name: chainConfig?.nativeCurrency?.name,
               decimals: 18,
               symbol: chainConfig?.nativeCurrency?.symbol,
             },
             rpcUrls: chainConfig["rpcUrls"],
             blockExplorerUrls:chainConfig['blockExplorerUrls']
           },
         ],
       });
     }
   }
 }
};